import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectToken } from "redux-store/features/authSlice";
import BrandModelService from "services/BrandModelService";
import LocationList from "./LocationList";
import AddVendorLocationModal from "./AddVendorLocationModal";
import SwitchAnswer from "components/SwitchAnswer";
import BrandService from "services/BrandService";

export default function SelectLocation({
  brandModelName,
  brandModelId,
  handleLocationSelect: onSelect,
}) {
  const navigate = useNavigate();
  const token = useSelector(selectToken);
  const dispatch = useDispatch();
  const service = new BrandModelService(token, dispatch);

  const [locationCount, setLocationCount] = useState(0);
  const [locationSearchMode, setLocationSearchMode] = useState("My Country");
  const [locations, setLocations] = useState([]);
  const [brandLocations, setBrandLocations] = useState([]);

  const [showAddVendorLocation, setShowAddVendorLocation] = useState(false);
  const openAddVendorLocationModal = () => {
    setShowAddVendorLocation(true);
  };
  const closeAddVendorLocationModal = async (location) => {
    if (location) setLocations((prev) => [location, ...prev]);
    setShowAddVendorLocation(false);
  };

  const handleUpdateLocationCentre = (location) => {
    setLocations((prev) =>
      prev.map((i) => {
        if (location.loc_b_m_id && i.loc_b_m_id === location.loc_b_m_id) {
          return {
            ...i,
            ...location,
          };
        }

        return i;
      }),
    );
  };

  const handleLocationSelect = (selectedLocation, status) => {
    console.log({ locations, brandLocations });
    onSelect(selectedLocation, status, [
      ...new Set([
        ...locations
          .filter((l) => l.status === 0 && l.loc_b_m_id)
          .map((l) => l.loc_b_m_id),
        ...brandLocations
          .filter((l) => l.status === 0 && l.loc_b_m_id)
          .map((l) => l.loc_b_m_id),
      ]),
    ]);
  };

  const handleUpdateBrandLocationCentre = (location) => {
    setBrandLocations((prev) =>
      prev.map((i) => {
        if (location.loc_b_m_id && i.loc_b_m_id === location.loc_b_m_id) {
          return {
            ...i,
            ...location,
          };
        }

        return i;
      }),
    );
  };

  const loadBrandModelLocationCount = async (
    brand_model_id,
    mode = "my_country",
  ) => {
    try {
      const { data } = await service.getLocationCount(brand_model_id, mode);
      const count = data.location_count;
      setLocationCount(count);
    } catch (error) {
      console.log("[error]", error);
    }
  };

  const loadBrandModelLocations = async (
    brand_model_id,
    mode = "my_country",
  ) => {
    try {
      const { data } = await service.getLocations(brand_model_id, mode);
      setLocations(data.data);
    } catch (error) {}
  };

  const loadBrandLocations = async (brand_model_id, mode = "my_country") => {
    try {
      const { data } = await BrandService.getLocations(
        brand_model_id,
        mode,
        token,
        dispatch,
      );
      setBrandLocations(data.data);
    } catch (error) {}
  };

  useEffect(() => {
    if (!brandModelId) return;
    const mode = locationSearchMode === "Global" ? "global" : "my_country";
    loadBrandModelLocationCount(brandModelId, mode);
    loadBrandModelLocations(brandModelId, mode);
    loadBrandLocations(brandModelId, mode);
  }, [brandModelId, locationSearchMode]);

  return (
    <>
      <AddVendorLocationModal
        show={showAddVendorLocation}
        handleClose={closeAddVendorLocationModal}
      />

      <div className="container">
        <h1 className="mb-4 userLevel-Title">Select vendor location</h1>

        <button
          className={`mb-4 btn btn-green`}
          type="button"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left"></i>
        </button>

        <h2 className={styles.brand_model_name}>{brandModelName}</h2>
        <p>This item has a location requirement.</p>

        <p className="locations">
          Locations available: <span>{locationCount}</span>
        </p>

        <div className={`${styles.location_mode_selector} mb-4`}>
          <SwitchAnswer
            rightLabel="My Country"
            leftLabel="Global"
            value={locationSearchMode}
            handleChange={setLocationSearchMode}
          />
        </div>

        <div className="mb-5">
          <LocationList
            locationCentre={locations}
            locationSearchMode={locationSearchMode}
            onLocationSelect={handleLocationSelect}
            updateLocationCentre={handleUpdateLocationCentre}
          />
        </div>

        <p className="locations">Other locations for this brand</p>

        <div className="mb-4">
          <LocationList
            locationCentre={brandLocations}
            locationSearchMode={locationSearchMode}
            onLocationSelect={handleLocationSelect}
            updateLocationCentre={handleUpdateBrandLocationCentre}
          />
        </div>

        <div className="my-4">
          <a className="d-block link fs-5" onClick={openAddVendorLocationModal}>
            Add new location
          </a>
        </div>
      </div>
    </>
  );
}
